/** MemberSheep's App Store page; null shows "Coming soon" instead of the badge. */
export const MEMBERSHEEP_APP_STORE_URL: string | null = null;

/** Apple's standard EULA, which MemberSheep's terms build on. */
export const APPLE_STANDARD_EULA = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

/** Browser UI colour (<meta name="theme-color">), which can't read a CSS token: keep it equal to --color-ms-blue in src/styles/index.css. */
export const MS_THEME_COLOR = '#0a84ff';
